var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loading-button',{attrs:{"icon":"PlusIcon","is-loading":_vm.is_loading},on:{"click":_vm.createLesson}},[_vm._v("Add New")])}
var staticRenderFns = []

export { render, staticRenderFns }